/* =========================================================
   ECOFRIT — REDISEÑO HOME
   JS del selector de formato + compra única/suscripción, y de
   la franja de reseñas. Vanilla, sin dependencias — la lógica
   de cobro real (Shopify Selling Plans / Seal) reemplaza el
   cálculo de precios de acá en la etapa Liquid, respetando este
   mismo comportamiento visual.
   ========================================================= */

(function () {
  "use strict";

  var prefersReducedMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)"
  ).matches;

  function clp(n) {
    return "$" + Number(n).toLocaleString("es-CL");
  }

  function scrollToSection(hash, updateHistory) {
    if (!hash || hash === "#") return false;
    var target = document.querySelector(hash);
    if (!target) return false;
    var chrome = document.querySelector(".site-chrome");
    var offset = (chrome ? chrome.getBoundingClientRect().height : 0) + 12;
    var top = target.getBoundingClientRect().top + window.scrollY - offset;
    if (updateHistory && window.location.hash !== hash) {
      window.history.pushState(null, "", hash);
    }
    window.scrollTo({
      top: Math.max(0, top),
      behavior: prefersReducedMotion ? "auto" : "smooth",
    });
    return true;
  }

  document.querySelectorAll('a[href^="#"]:not([href="#"])').forEach(function (link) {
    link.addEventListener("click", function (event) {
      var hash = link.getAttribute("href");
      if (scrollToSection(hash, true)) event.preventDefault();
    });
  });

  function getFormatoInput() {
    return document.querySelector('input[name="formato"]:checked');
  }

  function pulse(el, apply) {
    if (!el) return;
    if (prefersReducedMotion) {
      apply();
      return;
    }
    el.classList.add("is-updating");
    window.setTimeout(function () {
      apply();
      el.classList.remove("is-updating");
    }, 120);
  }

  function getSelectedPill() {
    var input = getFormatoInput();
    return input ? input.closest(".format-pill") : null;
  }

  function updatePillSelectedState() {
    document.querySelectorAll(".format-pill").forEach(function (pill) {
      var input = pill.querySelector('input[name="formato"]');
      pill.classList.toggle("is-selected", !!(input && input.checked));
    });
  }

  /* Un solo panel de detalle reacciona a la pill + al tipo de compra
     elegidos — no hay N tarjetas que actualizar, la foto del producto
     tampoco cambia. El "pulso" (emil-design-eng: transición de valor,
     nunca un salto abrupto) corre sincronizado en rendimiento y precio. */
  function updateFormatDetail() {
    var pill = getSelectedPill();
    if (!pill) return;

    var tipo = "unico";
    var unico = Number(pill.dataset.priceUnico);
    var was = pill.dataset.was ? Number(pill.dataset.was) : null;
    var current = unico;
    var liters = Number(pill.dataset.liters || 1);
    var name = pill.querySelector(".format-pill__name").textContent.trim();

    document.querySelectorAll(".format-pill").forEach(function (option) {
      var optionPrice = Number(option.dataset.priceUnico);
      var optionUnits = Number(option.dataset.liters || 1);
      var optionUnitEl = option.querySelector("[data-pill-unit-price]");
      if (optionUnitEl) {
        optionUnitEl.textContent =
          clp(Math.round(optionPrice / optionUnits)) +
          " por sobre recibido · recibes " + optionUnits;
      }
    });

    var yieldEl = document.querySelector("[data-detail-yield]");
    var unitsEl = document.querySelector("[data-detail-units]");
    var yieldWrap = yieldEl ? yieldEl.closest(".format-detail__yield") : null;
    pulse(yieldWrap, function () {
      if (yieldEl) yieldEl.textContent = pill.dataset.yield || "";
      if (unitsEl) unitsEl.textContent = pill.dataset.units || "";
    });

    var priceEl = document.querySelector("[data-price-display]");
    pulse(priceEl, function () {
      priceEl.textContent = clp(current);
    });

    var wasEl = document.querySelector("[data-was-display]");
    if (wasEl) {
      if (was && was > current) {
        wasEl.textContent = clp(was);
      } else {
        wasEl.textContent = "";
      }
    }

    var selectedFormat = getFormatoInput();
    var recurringForms = Array.prototype.slice.call(
      document.querySelectorAll("[data-ecofrit-product-form-for]")
    );
    var ctaEl = null;
    var variantInput = document.querySelector("[data-ecofrit-variant-id]");
    var sellingPlanInput = document.querySelector("[data-ecofrit-selling-plan]");
    var available = pill.dataset.available !== "false";

    if (recurringForms.length && selectedFormat) {
      recurringForms.forEach(function (formWrap) {
        var isActive = formWrap.dataset.ecofritProductFormFor === selectedFormat.value;
        formWrap.hidden = !isActive;
        formWrap.setAttribute("aria-hidden", isActive ? "false" : "true");
        if (isActive) ctaEl = formWrap.querySelector("[data-summary-cta]");
      });
    } else {
      ctaEl = document.querySelector("[data-summary-cta]");
      if (variantInput) variantInput.value = pill.dataset.variantId || "";
    }
    if (sellingPlanInput) {
      sellingPlanInput.value = "";
      sellingPlanInput.disabled = true;
    }
    if (ctaEl) {
      ctaEl.textContent = available ? "COMPRAR" : "AGOTADO";
      ctaEl.disabled = !available;
    }

    var productImage = document.querySelector("[data-product-image]");
    if (productImage && pill.dataset.image) {
      pulse(productImage, function () {
        productImage.src = pill.dataset.image;
        productImage.alt = pill.dataset.imageAlt || name;
      });
    }

    var unitPriceEl = document.querySelector("[data-unit-price]");
    if (unitPriceEl) {
      var pricePerSachet = clp(Math.round(current / liters));
      unitPriceEl.textContent =
        pricePerSachet + " por sobre recibido · " + liters + " litros resueltos";
    }
    var shippingEl = document.querySelector("[data-detail-shipping]");
    if (shippingEl) shippingEl.hidden = pill.dataset.freeShipping !== "true";

    var stickyName = document.querySelector("[data-sticky-pack]");
    var stickyPrice = document.querySelector("[data-sticky-price]");
    var stickyButton = document.querySelector("[data-sticky-buy]");
    if (stickyName) stickyName.textContent = name;
    if (stickyPrice) stickyPrice.textContent = clp(current);
    if (stickyButton) stickyButton.disabled = !available;
  }

  function refreshAll() {
    updatePillSelectedState();
    updateFormatDetail();
  }

  document
    .querySelectorAll('input[name="formato"]')
    .forEach(function (input) {
      input.addEventListener("change", refreshAll);
    });


  /* La compra aparece inmediatamente después del hero/ticker. Se hace al
     cargar el script para conservar un fallback editorial completo sin JS. */
  var heroSection = document.querySelector(".hero");
  var formatsSection = document.querySelector(".formats");
  if (heroSection && formatsSection && heroSection.nextElementSibling !== formatsSection) {
    heroSection.insertAdjacentElement("afterend", formatsSection);
  }

  refreshAll();

  function selectPack5AndScroll() {
    var pack5 = document.querySelector('input[name="formato"][value="pack5"]');
    if (pack5) {
      pack5.checked = true;
      refreshAll();
    }
    scrollToSection("#formatos", false);
  }

  document.querySelectorAll("[data-buy-link]").forEach(function (link) {
    link.addEventListener("click", function (event) {
      event.preventDefault();
      selectPack5AndScroll();
    });
  });

  document.querySelectorAll(".hero__label, .hero__trust, .hero__ticker, .formats__head").forEach(function (block) {
    block.classList.add("ecofrit-buy-target");
    block.setAttribute("role", "link");
    block.setAttribute("tabindex", "0");
    block.setAttribute("aria-label", "Ver packs Ecofrit");
    block.addEventListener("click", selectPack5AndScroll);
    block.addEventListener("keydown", function (event) {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        selectPack5AndScroll();
      }
    });
  });

  var productImageButton = document.querySelector("[data-format-image-button]");
  if (productImageButton) {
    productImageButton.addEventListener("click", function () {
      var button = document.querySelector('[data-ecofrit-product-form-for]:not([hidden]) [data-summary-cta]') || document.querySelector("[data-summary-cta]");
      if (button) button.scrollIntoView({ behavior: prefersReducedMotion ? "auto" : "smooth", block: "center" });
    });
  }

  var stickyBar = document.querySelector("[data-sticky-bar]");
  var stickyButton = document.querySelector("[data-sticky-buy]");
  if (stickyBar && stickyButton) {
    stickyButton.addEventListener("click", function () {
      var activeButton = document.querySelector('[data-ecofrit-product-form-for]:not([hidden]) [data-summary-cta]') || document.querySelector("[data-summary-cta]");
      if (activeButton && !activeButton.disabled) activeButton.click();
    });
    function refreshStickyBar() {
      var activeButton = document.querySelector('[data-ecofrit-product-form-for]:not([hidden]) [data-summary-cta]') || document.querySelector("[data-summary-cta]");
      stickyBar.hidden = window.innerWidth > 767 || !activeButton || activeButton.getBoundingClientRect().bottom >= 0;
    }
    window.addEventListener("scroll", refreshStickyBar, { passive: true });
    window.addEventListener("resize", refreshStickyBar);
    document.querySelectorAll('input[name="formato"]').forEach(function (input) {
      input.addEventListener("change", refreshStickyBar);
    });
    refreshStickyBar();
  }

  /* ---------- Carrusel de reseñas: foco central + peek ----------
     Blueland-style: una tarjeta centrada, las vecinas se atenúan.
     El centrado real (padding calculado) + la atenuación por scroll
     + los puntos + las flechas están todos sincronizados desde acá. */
  (function setupReviewsCarousel() {
    var stage = document.getElementById("reviews-strip");
    if (!stage) return;
    var cards = Array.prototype.slice.call(
      stage.querySelectorAll(".review-card")
    );
    if (!cards.length) return;
    var dotsWrap = document.getElementById("reviews-dots");

    function centerPadding() {
      var cardWidth = cards[0].getBoundingClientRect().width;
      var pad = Math.max(0, (stage.clientWidth - cardWidth) / 2);
      stage.style.paddingLeft = pad + "px";
      stage.style.paddingRight = pad + "px";
    }

    function closestIndex() {
      var stageRect = stage.getBoundingClientRect();
      var stageCenter = stageRect.left + stageRect.width / 2;
      var best = 0;
      var bestDist = Infinity;
      cards.forEach(function (card, i) {
        var r = card.getBoundingClientRect();
        var dist = Math.abs(r.left + r.width / 2 - stageCenter);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      });
      return best;
    }

    function updateProximity() {
      var stageRect = stage.getBoundingClientRect();
      var stageCenter = stageRect.left + stageRect.width / 2;
      cards.forEach(function (card) {
        var r = card.getBoundingClientRect();
        var dist = Math.abs(r.left + r.width / 2 - stageCenter);
        var proximity = Math.max(0, 1 - dist / (stageRect.width / 2));
        card.style.setProperty("--proximity", proximity.toFixed(3));
      });
      var active = closestIndex();
      if (dotsWrap) {
        dotsWrap.querySelectorAll(".reviews__dot").forEach(function (dot, i) {
          dot.classList.toggle("is-active", i === active);
        });
      }
      document
        .querySelectorAll("[data-review-scroll]")
        .forEach(function (btn) {
          var dir = Number(btn.dataset.reviewScroll);
          if (dir < 0) btn.disabled = active === 0;
          if (dir > 0) btn.disabled = active === cards.length - 1;
        });
    }

    function goTo(index) {
      var target = cards[Math.max(0, Math.min(cards.length - 1, index))];
      target.scrollIntoView({
        behavior: prefersReducedMotion ? "auto" : "smooth",
        inline: "center",
        block: "nearest",
      });
    }

    if (dotsWrap) {
      cards.forEach(function (_, i) {
        var dot = document.createElement("button");
        dot.type = "button";
        dot.className = "reviews__dot";
        dot.setAttribute("aria-label", "Ir a reseña " + (i + 1));
        dot.addEventListener("click", function () {
          goTo(i);
        });
        dotsWrap.appendChild(dot);
      });
    }

    document.querySelectorAll("[data-review-scroll]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        goTo(closestIndex() + Number(btn.dataset.reviewScroll));
      });
    });

    var ticking = false;
    stage.addEventListener("scroll", function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        updateProximity();
        ticking = false;
      });
    });

    window.addEventListener("resize", centerPadding);
    centerPadding();
    updateProximity();
  })();

  /* ---------- "Ecofrit lo resuelve fácilmente": revelado en orden ----------
     emil-design-eng: la animación necesita un propósito citable —
     acá es "explanation" (mostrar el proceso en su propio orden).
     impeccable: un reveal nunca puede partir de invisible-por-CSS;
     `.js-ready` (que habilita el estado oculto) solo la agrega este
     script, así que si JS no corre el contenido queda visible igual. */
  var stepsList = document.querySelector(".steps__list");
  if (stepsList && !prefersReducedMotion && "IntersectionObserver" in window) {
    stepsList.classList.add("js-ready");
    var stepsObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            stepsList.classList.add("is-visible");
            stepsObserver.disconnect();
          }
        });
      },
      { threshold: 0.3 }
    );
    stepsObserver.observe(stepsList);

    /* Red de seguridad: si por lo que sea el observer nunca dispara
       (captura de página completa sin scroll real, herramienta
       headless, etc.), el contenido no puede quedar oculto para
       siempre — impeccable es explícito sobre este riesgo. */
    window.setTimeout(function () {
      stepsList.classList.add("is-visible");
      stepsObserver.disconnect();
    }, 2500);
  }

  /* Las botellas reaccionan una vez cuando la historia entra en pantalla.
     El hover sigue disponible en escritorio como segunda microinteracción. */
  var bottleCorner = document.querySelector(".bottle-corner");
  if (bottleCorner && !prefersReducedMotion && "IntersectionObserver" in window) {
    var bottleObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          bottleCorner.classList.add("is-arriving");
          bottleObserver.disconnect();
          window.setTimeout(function () {
            bottleCorner.classList.remove("is-arriving");
          }, 900);
        });
      },
      { threshold: 0.38 }
    );
    bottleObserver.observe(bottleCorner);
  }

  /* La franja de beneficios entra una sola vez de izquierda a derecha.
     Se anima como conjunto para mantener su lectura editorial y para no
     competir con la banda continua del hero. */
  var stepsProps = document.querySelector(".steps__props");
  if (stepsProps && !prefersReducedMotion && "IntersectionObserver" in window) {
    stepsProps.classList.add("js-ready");
    var propsObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            stepsProps.classList.add("is-visible");
            propsObserver.disconnect();
          }
        });
      },
      { threshold: 0.25 }
    );
    propsObserver.observe(stepsProps);

    window.setTimeout(function () {
      stepsProps.classList.add("is-visible");
      propsObserver.disconnect();
    }, 3000);
  }

  /* ---------- Impacto acumulado: cuenta una vez hasta la cifra publicada ----------
     Es una animación de revelado, no un contador de ventas en vivo. La
     cifra final ya existe en el HTML como fallback y no depende del JS. */
  var impactCounter = document.querySelector("[data-impact-counter]");
  if (impactCounter) {
    var impactTarget = Number(impactCounter.dataset.impactValue || 0);
    var impactStart = Number(impactCounter.dataset.impactStart || 0);
    var formatImpact = function (value) {
      return "+" + Math.round(value).toLocaleString("es-CL");
    };

    if (prefersReducedMotion || !("IntersectionObserver" in window)) {
      impactCounter.textContent = formatImpact(impactTarget);
    } else {
      var impactStarted = false;
      var impactObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting || impactStarted) return;
            impactStarted = true;
            impactObserver.disconnect();
            impactCounter.textContent = formatImpact(impactStart);
            var startTime = null;
            var duration = 3200;

            var countImpact = function (now) {
              if (startTime === null) startTime = now;
              var progress = Math.min((now - startTime) / duration, 1);
              var eased = 1 - Math.pow(1 - progress, 3);
              var rawValue = impactStart + (impactTarget - impactStart) * eased;
              var steppedValue = Math.round(rawValue / 250000) * 250000;
              impactCounter.textContent = formatImpact(steppedValue);
              if (progress < 1) {
                window.requestAnimationFrame(countImpact);
              } else {
                impactCounter.textContent = formatImpact(impactTarget);
              }
            };

            window.requestAnimationFrame(countImpact);
          });
        },
        { threshold: 0.45 }
      );

      impactObserver.observe(impactCounter);
    }
  }

  /* ---------- Parallax sutil en decoraciones ----------
     frontend-design: motion "ambient" — profundidad, no un truco.
     Factor pequeño (0.1-0.2) a propósito: el pedido fue "parallax
     sutil", no un efecto que compita con el contenido. Sin JS o con
     movimiento reducido, el elemento simplemente no se mueve — nunca
     depende de esto para verse bien (mismo principio que el reveal
     de Pasos). */
  var parallaxEls = Array.prototype.slice.call(
    document.querySelectorAll("[data-parallax]")
  );
  if (parallaxEls.length && !prefersReducedMotion) {
    var parallaxTicking = false;
    var applyParallax = function () {
      var viewportH = window.innerHeight;
      parallaxEls.forEach(function (el) {
        var speed = Number(el.dataset.parallax) || 0.15;
        var rect = el.getBoundingClientRect();
        var centerOffset = rect.top + rect.height / 2 - viewportH / 2;
        el.style.setProperty(
          "--parallax-y",
          centerOffset * speed * -1 + "px"
        );
      });
      parallaxTicking = false;
    };
    window.addEventListener("scroll", function () {
      if (!parallaxTicking) {
        window.requestAnimationFrame(applyParallax);
        parallaxTicking = true;
      }
    });
    applyParallax();
  }
})();
